<template>
  <article id="CookieCutter">
    <WelcomeSection />
    <HowItWorks />
    <StatsVideoSection />
    <Benefits />
    <FAQ />
  </article>
</template>

<script>
import WelcomeSection from "../components/CookieCutter/WelcomeSection.vue";
import HowItWorks from "../components/CookieCutter/HowItWorks.vue";
import StatsVideoSection from "../components/CookieCutter/StatsVideoSection.vue";
import Benefits from "../components/CookieCutter/Benefits.vue";
import FAQ from "../components/FAQ.vue";

export default {
  name: "CookieCutter",
  components: {
    WelcomeSection,
    HowItWorks,
    StatsVideoSection,
    Benefits,
    FAQ,
  },
};
</script>
